import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AccountService} from "../../services/account.service";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-resident-menu',
  templateUrl: './resident-menu.component.html',
  styleUrls: ['./resident-menu.component.css']
})
export class ResidentMenuComponent implements OnInit {

  @Input()
  isResident: boolean = false;
  smartHomeMarketingUrl : string = environment.SmartHome.MarketingUrl;

  constructor(private router: Router) { }

  ngOnInit(): void {

  }

  onLeaseClick() {
    if (this.isResident) {
      this.router.navigate(['/leases/non-legacy-leases-dashboard']);
    }
  }
  onRenewalClick() {
    if (this.isResident) {
      this.router.navigate(['/renewalcog/renewal-dashboard']);
    }
  }
  onSmartHomeClick() {
    if (this.isResident) {
      this.router.navigate(['/smarthome/devices']);
    } else {
      window.location.href = this.smartHomeMarketingUrl;
    }
  }

  onMaintenanceClick() {
    if (this.isResident) {
      this.router.navigate(['/maintenance/dashboard']);
    }
  }

}
